import { SearchDetailCondition } from 'components/SearchSideBar/SearchDetailCondition';
import { FC, memo } from 'react';
import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { SidebarSection } from 'components/SearchSideBar/SidebarSection';
import {
  EmployNumType,
  EmployeeAverageAgeType,
  EstablishType,
  HolidayAndWayOfWorkingType,
  JobOfferKindType,
  LanguageSkillType,
  PositionType,
  RequirementType,
  WelfareBenefitsType,
  WorkingPlaceEnvironmentType,
} from './types';
import { UpdateJobCountType } from '../types';

/**
 * Detailsコンポーネントのプロパティ
 */
interface Props {
  /** 詳細検索条件 */
  searchDetail: {
    holidayAndWayOfWorking: HolidayAndWayOfWorkingType;
    requirements: RequirementType;
    workingPlaceEnvironment: WorkingPlaceEnvironmentType;
    welfareBenefits: WelfareBenefitsType;
    languageSkill: LanguageSkillType;
    positions: PositionType;
    employeeAverageAge: EmployeeAverageAgeType;
    employNum: EmployNumType;
    establish: EstablishType;
    jobOfferKind: JobOfferKindType;
  };
  /** 求人数を更新する関数 */
  updateJobCount: UpdateJobCountType;
  /** オーバーレイの表示状態を変更する関数 */
  onChangeIsShowOverlay: () => void;
}

/**
 * Details
 * 検索詳細条件を表示するサイドバーセクションコンポーネント
 *
 * @param {Props} props コンポーネントのプロパティ
 * @returns {JSX.Element}
 */
export const Details: FC<Props> = memo(
  ({
    searchDetail: {
      holidayAndWayOfWorking,
      requirements,
      workingPlaceEnvironment,
      welfareBenefits,
      languageSkill,
      positions,
      employeeAverageAge,
      employNum,
      establish,
      jobOfferKind,
    },
    updateJobCount,
    onChangeIsShowOverlay,
  }) => {
    return (
      <SidebarSection title="詳細条件">
        <ConditionsAreaWrapper>
          <SearchDetailCondition
            title="休日・働き方"
            list={holidayAndWayOfWorking.holidayAndWayOfWorkingList}
            onChange={(event) => {
              updateJobCount({
                holidayAndWayOfWorking:
                  holidayAndWayOfWorking.updateIsCheckedHolidayAndWayOfWorkingList(
                    event
                  ),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="募集・採用情報"
            list={requirements.requirementList}
            onChange={(event) => {
              updateJobCount({
                requirements:
                  requirements.updateIsCheckedRequirementList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="会社・職場の環境"
            list={workingPlaceEnvironment.workingPlaceEnvironmentList}
            onChange={(event) => {
              updateJobCount({
                workplaceEnvironment:
                  workingPlaceEnvironment.updateIsCheckedWorkingPlaceEnvironmentList(
                    event
                  ),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="待遇・福利厚生"
            list={welfareBenefits.welfareBenefitsList}
            onChange={(event) => {
              updateJobCount({
                welfareBenefits:
                  welfareBenefits.updateIsCheckedWelfareBenefitsList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="語学"
            list={languageSkill.languageSkillList}
            onChange={(event) => {
              updateJobCount({
                languageSkills:
                  languageSkill.updateIsCheckedLanguageSkillList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="仕事内容"
            list={positions.positionList}
            onChange={(event) => {
              updateJobCount({
                positions: positions.updateIsCheckedPositionList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="社員の平均年齢"
            list={employeeAverageAge.employeeAverageAgeList}
            onChange={(event) => {
              updateJobCount({
                employeeAverageAge:
                  employeeAverageAge.updateIsCheckedEmployeeAverageAgeList(
                    event
                  ),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="従業員数"
            list={employNum.employNumList}
            onChange={(event) => {
              updateJobCount({
                employNum: employNum.updateIsCheckedEmployNumList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="設立"
            list={establish.establishList}
            onChange={(event) => {
              updateJobCount({
                establish: establish.updateIsCheckedEstablishList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
          <SearchDetailCondition
            title="応募方法"
            list={jobOfferKind.jobOfferKindList}
            onChange={(event) => {
              updateJobCount({
                jobOfferKind:
                  jobOfferKind.updateIsCheckedJobOfferKindList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
        </ConditionsAreaWrapper>
      </SidebarSection>
    );
  }
);

Details.displayName = 'Details';
